/** Admin console routes — same app chrome (Navbar), grouped under /admin */

export const ADMIN_CONSOLE_NAV = [
  { label: 'Overview', path: '/admin', end: true },
  { label: 'Users', path: '/admin/users' },
  { label: 'Bulk upload', path: '/admin/bulk-upload' },
  { label: 'Restrictions', path: '/admin/restrictions' },
];

/** Visible only to ROLE_SYSTEM_ADMIN */
export const ADMIN_SYSTEM_NAV = [
  { label: 'Administrator controls', path: '/admin/system' },
];

/** Learner-app tools admins often need while managing the platform */
export const ADMIN_CONSOLE_LINKS = [
  { label: 'Question library', path: '/library' },
  { label: 'Analytics', path: '/dashboard#study-analytics' },
  { label: 'Marketing site', path: '/product' },
];

export const ADMIN_QUICK_LINKS = [
  {
    title: 'Question library',
    description: 'Search, edit, and curate the public question bank.',
    path: '/library',
  },
  {
    title: 'Learning analytics',
    description: 'Read rates, likes, and engagement charts.',
    path: '/dashboard#study-analytics',
  },
  {
    title: 'Marketing site',
    description: 'Preview public pages (features, pricing, security).',
    path: '/product',
  },
];

export const ADMIN_FEATURE_MATRIX = [
  {
    section: 'Users & security',
    items: [
      { label: 'User directory', path: '/admin/users', doc: 'ROLE_ADMIN directory' },
      { label: 'Online presence', path: '/admin/users', doc: '5-minute activity window' },
      { label: 'Notebook restrictions', path: '/admin/restrictions', doc: 'GET /api/get-restrictions' },
    ],
  },
  {
    section: 'Content',
    items: [
      { label: 'Bulk upload & AI generate', path: '/admin/bulk-upload', doc: 'ai-architecture — /ai/generate' },
      { label: 'Single question add', path: '/admin/bulk-upload', doc: 'POST /api/add-questions' },
      { label: 'Edit / delete questions', path: '/settings?tab=manage', doc: 'GET/PATCH /api/admin/questions' },
    ],
  },
  {
    section: 'Learning & feedback',
    items: [
      { label: 'Per-question feedback', path: '/library', doc: 'GET/POST exception APIs on cards' },
      { label: 'Saved / practice / review', path: '/dashboard', doc: 'Learning loop' },
    ],
  },
  {
    section: 'Platform',
    items: [
      { label: 'AI explain & suggest', path: '/admin', doc: 'Daily quotas on overview' },
      { label: 'Billing & plans', path: '/admin', doc: 'Stripe / demo mode on overview' },
      { label: 'Account export & MFA', path: '/settings', doc: 'Settings → Security' },
    ],
  },
];
